import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[billing] render error", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: "2rem", fontFamily: "system-ui, sans-serif", maxWidth: 720 }}>
          <h1 style={{ fontSize: "1.25rem", marginBottom: "0.75rem" }}>Erreur Invoice</h1>
          <p style={{ color: "#666", marginBottom: "1rem" }}>
            L&apos;interface a rencontré une erreur. Ouvrez la console (F12) pour le détail.
          </p>
          <pre
            style={{
              background: "#f8f9fa",
              padding: "1rem",
              borderRadius: 8,
              overflow: "auto",
              fontSize: 13,
            }}
          >
            {this.state.error.message}
          </pre>
          <p style={{ marginTop: "1rem" }}>
            <a href="/login">Retour connexion</a>
            {" · "}
            <a href="/index">Réessayer dashboard</a>
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}
